import React, { Component } from "react";
import me from "../images/logo192.jpg";
import banner from "../images/banner.jpg";
class BannerView extends Component {
  render() {
    return (
      <div
        className="banner-container container-fluid text-center"
        style={{ backgroundImage: `url(${banner})` }}
      >
        <div className="pt-4" />
        <img src={me} className="rounded-circle m-2 banner-avatar" />
        <p className="banner-text m-2 text-white font-weight-bold">
          A Developer, Learner, Badmintonist
        </p>
        <p className="banner-text m-2" style={{ color: 'yellow' }}>
          I solve problems with code.
        </p>
      </div>
    );
  }
}

export default BannerView;
